const minConvosToShowSearch = 10;
const minFriendsToShowFilter = 7;

export {
  minConvosToShowSearch,
  minFriendsToShowFilter,
};
